<section class="title-bar content-padding first-item ">
  <div class="wrapper nowrap">
    <h2 class="title-heading">{{ partnerDeliveryRule?.id ? "Modifica" : "Nuovo"}} regola di consegna del partner</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">
      </span>
    </div>
  </div>
</section>

<section id="modificaConsegna" class="content-padding">
    <div class="narrow-wrapper">
        <form class="has-cols" [formGroup]="partnerDeliveryRulesForm" (ngSubmit)="onSubmit()" *ngIf="partnerDeliveryRulesForm">

            <div class="delivery-colle-data-box">
                <fieldset>
                    <legend>REGOLE:</legend>

                    <div class="col-48 grid-element">
                        <label>Valido da{{ partnerDeliveryRulesForm.get('validFrom') | required }}</label>
                        <input type="date" formControlName="validFrom">
                        <app-error-html-handler [ctrl]="partnerDeliveryRulesForm.get('validFrom')" [messages]="formValidationMsgs.validFrom"></app-error-html-handler>
                    </div>

                    <div class="col-48 grid-element">
                        <label>Valido fino a{{ partnerDeliveryRulesForm.get('validTill') | required }}</label>
                        <input type="date" formControlName="validTill">
                        <app-error-html-handler [ctrl]="partnerDeliveryRulesForm.get('validTill')" [messages]="formValidationMsgs.validTill"></app-error-html-handler>
                    </div>

                    <div class="col-48 grid-element" formGroupName="partner">
                        <label>Partner{{ partnerDeliveryRulesForm.get('partner').get('id') | required }}</label>
                        <select id="selezionePartner" type="text" formControlName="id">
                          <option disabled></option>
                          <option *ngFor="let partner of partners" [value]="partner.id">{{partner.businessName}}</option>
                        </select>
                        <app-error-html-handler [ctrl]="partnerDeliveryRulesForm.get('partner').get('id')" [messages]="formValidationMsgs.partner.id"></app-error-html-handler>
                    </div> 

                    <div class="col-48 grid-element">
                        <label for="name">Tipo Servizio{{ partnerDeliveryRulesForm.get('serviceType') | required }}</label>
                        <select name="" id="" formControlName="serviceType">
                          <option disabled="true" selected="true">Seleziona il tipo di servizio</option>
                          <option value="hourlyrate">Services in Ora</option>
                          <option value="fixedprice">Servizi a Prezzo Fisso</option>
                        </select>
                        <app-error-html-handler [ctrl]="partnerDeliveryRulesForm.get('serviceType')" [messages]="formValidationMsgs.serviceType"></app-error-html-handler>
                    </div>

                    <div class="col-48 grid-element">
                        <label>KM Distance{{ partnerDeliveryRulesForm.get('kmLimit') | required }}</label>
                        <input type="text" formControlName="kmLimit" placeholder="">
                        <app-error-html-handler [ctrl]="partnerDeliveryRulesForm.get('kmLimit')" [messages]="formValidationMsgs.kmLimit"></app-error-html-handler>
                    </div>

                </fieldset>
            </div>

            <div class="delivery-colle-data-box" style="margin-top: 15px;">
                <fieldset>
                    <legend>NUMERO REGOLE DI CONSEGNA:</legend>

                    <div class="col-48 grid-element">
                        <label class="original-label">
                            <input type="checkbox" formControlName="perDayDeliveryRule" (change)="onCheckboxChange('perDayDeliveryRule')">
                            REGOLA DEL NUMERO GIORNALIERO DI CONSEGNA
                        </label>
                    </div>
                    
                    <div class="col-48 grid-element">
                        <label class="original-label">
                            <input type="checkbox" formControlName="totalDeliveryRule" (change)="onCheckboxChange('totalDeliveryRule')">
                            NUMERO TOTALE DI REGOLA DI CONSEGNA
                        </label>
                    </div>

                </fieldset>
            </div>

            <div class="delivery-colle-data-box" style="margin-top: 15px;" [ngClass]="{'hidden': !partnerDeliveryRulesForm.get('perDayDeliveryRule').value}">
                <fieldset>
                    <legend>REGOLA DEL NUMERO GIORNALIERO DI CONSEGNA:</legend>

                    <div class="col-48 grid-element">
                        <label>Intervallo di tempo{{ partnerDeliveryRulesForm.get('startTimeRange') | required }}</label>
                        <div class="time-range">
                            <div>
                                <input type="time" formControlName="startTimeRange">
                                <app-error-html-handler [ctrl]="partnerDeliveryRulesForm.get('startTimeRange')" [messages]="formValidationMsgs.startTimeRange"></app-error-html-handler>
                            </div>
                            <div style="text-align: center;">&nbsp;-&nbsp;</div>
                            <div>
                                <input type="time" formControlName="endTimeRange">
                                <app-error-html-handler [ctrl]="partnerDeliveryRulesForm.get('endTimeRange')" [messages]="formValidationMsgs.endTimeRange"></app-error-html-handler>
                            </div>
                        </div>
                    </div>

                    <div class="col-48 grid-element">
                        <label>Numero giornaliero di consegne{{ partnerDeliveryRulesForm.get('perDayDeliveryLimit') | required }}</label>
                        <input type="text" formControlName="perDayDeliveryLimit" placeholder="">
                        <app-error-html-handler [ctrl]="partnerDeliveryRulesForm.get('perDayDeliveryLimit')" [messages]="formValidationMsgs.perDayDeliveryLimit"></app-error-html-handler>
                    </div>

                    <div class="col-48 grid-element days-label-container" *ngFor="let d of weekDays; let i = index">
                        <label for="{{ d }}"></label>
                        <label class="original-label" for="{{ d }}">
                            <input type="checkbox" id="{{ d }}" [(ngModel)]="days[i].selected" [ngModelOptions]="{standalone: true}">
                                {{ d.toUpperCase() }}
                        </label>
                    </div>
                    <br class="clear">

                </fieldset>
            </div>

            <div class="delivery-colle-data-box" style="margin-top: 15px;" [ngClass]="{'hidden': !partnerDeliveryRulesForm.get('totalDeliveryRule').value}">
                <fieldset>
                    <legend>NUMERO TOTALE DI REGOLE DI CONSEGNA:</legend>

                    <div class="col-48 grid-element">
                        <label>Intervallo di tempo{{ partnerDeliveryRulesForm.get('startTimeRange') | required }}</label>
                        <div class="time-range">
                            <div>
                                <input type="time" formControlName="startTimeRange">
                                <app-error-html-handler [ctrl]="partnerDeliveryRulesForm.get('startTimeRange')" [messages]="formValidationMsgs.startTimeRange"></app-error-html-handler>
                            </div>
                            <div style="text-align: center;">&nbsp;-&nbsp;</div>
                            <div>
                                <input type="time" formControlName="endTimeRange">
                                <app-error-html-handler [ctrl]="partnerDeliveryRulesForm.get('endTimeRange')" [messages]="formValidationMsgs.endTimeRange"></app-error-html-handler>
                            </div>
                        </div>
                    </div>

                    <div class="col-48 grid-element">
                        <label>Numero totale di consegne{{ partnerDeliveryRulesForm.get('totalDeliveryLimit') | required }}</label>
                        <input type="text" formControlName="totalDeliveryLimit" placeholder="">
                        <app-error-html-handler [ctrl]="partnerDeliveryRulesForm.get('totalDeliveryLimit')" [messages]="formValidationMsgs.totalDeliveryLimit"></app-error-html-handler>
                    </div>

                </fieldset>
            </div>

            <div class="delivery-colle-data-box" style="margin-top: 15px;">
                <fieldset>
                    <legend>APPLICABILE ALLA CONSEGNA:</legend>

                    <div class="col-48 grid-element">
                        <label for="billable"></label>
                        <label class="original-label">
                        <input type="checkbox" name="billable" formControlName="billable">
                        DA FATTURARE
                        </label>
                    </div>
                
                    <div class="col-48 grid-element">
                        <label for="payable"></label>
                        <label class="original-label">
                        <input type="checkbox" name="payable" formControlName="payable">
                        DA PAGARE
                        </label>
                    </div>

                    <div class="col-48 grid-element">
                        <label>plus/minus prezzo for fatturazione</label>
                        <input type="text" formControlName="additionalPrice" placeholder="">
                        <app-error-html-handler [ctrl]="partnerDeliveryRulesForm.get('additionalPrice')" [messages]="formValidationMsgs.additionalPrice"></app-error-html-handler>
                    </div>
                
                    <div class="col-48 grid-element">
                        <label>plus/minus prezzo for stipendi</label>
                        <input type="text" formControlName="valetAdditionalPrice" placeholder="">
                        <app-error-html-handler [ctrl]="partnerDeliveryRulesForm.get('valetAdditionalPrice')" [messages]="formValidationMsgs.valetAdditionalPrice"></app-error-html-handler>
                    </div>

                </fieldset>

                <div class="delivery-colle-data-box" style="margin-top: 15px;">
                    <fieldset>
                        <legend>ASSOCIATE PARTNERS:</legend>
                        <div class="grid-element-full" *ngIf="groups.includes('admin') || groups.includes('operation')">
                            <label style="position: relative; top: 20px;">Partners</label>
                            <div formArrayName="associatePartnerWithDeliveryRules" class="mb-5">
                                <div class="offer-products" *ngFor="let partnerForm of partnerDeliveryRulesForm.get('associatePartnerWithDeliveryRules').controls; let i = index">
                                    <div [formGroupName]="i" class="" style="display: table; width: 100%;">
                                        <label for=""></label>
                                        <div style="display: table-cell; width: 19px;">
                                            <i class="far fa-times-circle hvr-grow remove-product"  (click)="removeAssociatePartner(i)"></i>
                                        </div>
                                        <div class="product-q" formGroupName="partner">
                                            <div class="porduct-qty">
                                                <div class="province-input">
                                                    <label for=""></label>
                                                    <ng-select 
                                                        formControlName="id"
                                                        class="product-category"
                                                        [multiple]="false" 
                                                        [hideSelected]="true"
                                                        [closeOnSelect]="true"
                                                        [searchable]="true" 
                                                        [clearable]="true"
                                                        [virtualScroll]="true"
                                                    >
                                                        <ng-option *ngFor="let partner of partners" [value]="partner.id" [disabled]="isAssociatePartnerOptionDisabled(partner)">{{partner.businessName}}</ng-option>
                                                    </ng-select>
                                                </div>
                                            </div>
                                        </div>
                                        <app-error-html-handler [ctrl]="partnerForm?.controls?.partner.controls?.id" [messages]="formValidationMsgs?.associatePartnerWithDeliveryRules?.partner.id"></app-error-html-handler>
                                    </div>
                                </div>
                            </div>
                            <div class="center" style="width: 100%;">
                                <button class="btn mt-0" (click)="$event.preventDefault(); addAssociatePartner()">
                                    Aggiungi Prodotto<i class="ml-10 fas fa-plus"></i>
                                </button>
                            </div>
                        </div>
                    </fieldset>
                </div>

                <div class="center" style="margin-top: 15px;">
                    <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()" [disabled]="!partnerDeliveryRulesForm?.valid || tmpBtnDisabled">Salva<i class="ml-10 far fa-save"></i></button>
                </div>
            </div>
        </form>
    </div>
</section>
